import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormatDataTableGlobal, FormatterDolar } from 'src/app/web/util/formatDataTable';

import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceEjecutive } from 'src/app/web/apis/ApiServiceEjecutive';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import {Chart} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FormatChatsOptionBarGlobal } from 'src/app/web/util/formatChart';
import * as moment from 'moment';


@Component({
  selector: 'app-forecast',
  templateUrl: './forecast.component.html',
  styleUrls: ['./forecast.component.scss']
})
export class ForecastComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};


  formSearch:FormGroup
  listFilterClient = [];
  listPlayOption = [];
  listOption = [];
  dateGarfi = [];
  payTodayGarfi = [];
  payPastGarfi = [];
  listYear = [];
  year= "";
  grafico;

  
  dropdownSettings = {};
  filterOperation = [];
  filterComercialOrigen = [];
  typeMoney = ""
  listTypeService = [];

  chart1 = {
    data :{
      
      labels: this.dateGarfi,
      datasets: [{
          label: 'Backlog',
          data: this.payPastGarfi,
          backgroundColor: 'grey',
          borderColor: 'grey',
          borderWidth: 2,
      },
      {
        label: 'Cierre Ventas (Nuevo + Ext)',
        data: this.payTodayGarfi,
        backgroundColor: 'green',
        borderColor: 'green',
        borderWidth: 2,
      }
    ]
    },
    options:FormatChatsOptionBarGlobal(),
    plugins: [ChartDataLabels],

  };
  
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private errorService:ErrorService,
    private apiService: ApiServiceEjecutive) { 

  }

  ngOnInit(): void {
    
    this.dtOptions = FormatDataTableGlobal();

    this.formSearch = this.fb.group({
      optionTypeYear:0,
      optionTypePay: 0,
      optionState:'',
      optionClient:0,
      selectComercialOrigen: [''],
      selectOperation: [''],
      optionTypeService: [''],
      currencyTransf: 0,
      });


   let yearActual = moment(new Date()).format('YYYY');
   let endYear = Number(yearActual) + 2;

   for(let i = endYear; 2009 != i; i--){
    let info ={
      id: i,
      name: i
    }
    this.listYear.push(info)
   }
    this.year = yearActual;
    console.log(this.year)
    this.typeMoney = "UF"
    this.iniService(yearActual.toString(), this.formSearch.value.optionTypePay, this.formSearch.value.optionState, this.formSearch.value.optionClient,  this.formSearch.value.selectComercialOrigen, this.formSearch.value.selectOperation, this.formSearch.value.optionTypeService, "2")
  }

  iniService(year, typePay, stateSw, clientId, commercialOrigin, operation, typeService, currencyTransf){

    this.spinner.show();
    this.apiService.getService('list-forecast?year='+year+'&typePay='+typePay+'&stateSw='+stateSw+'&clientId='+clientId+'&commercialOrigin='+commercialOrigin+'&operation='+operation+'&serviceType='+typeService+'&currencyTransf='+currencyTransf+'')
    .subscribe({
      next: (rs: any) => {
      if (rs.code == null) {

        if(this.listTypeService.length == 0){
          this.listTypeService = rs.listServiceType
          this.filterComercialOrigen = rs.listCommercialOrigin
          this.filterOperation = rs.listOperation
          this.listPlayOption = rs.listPlayOption
          this.listOption = rs.listOption
        }

      if(rs.listInfoGrafit.dateGarfi != null){
        this.dateGarfi = rs.listInfoGrafit.dateGarfi;
        this.payTodayGarfi = rs.listInfoGrafit.payTodayGarfi;
        this.payPastGarfi = rs.listInfoGrafit.payPastGarfi;
        this.listFilterClient = rs.listFilterClient

      }
      this.spinner.hide();
      this.chart()

      this.rerender();

      } else {
        this.spinner.hide();
        Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
      }
    },
    error: (error) => {
      this.errorService.error(error);
    },
  });
  }


  async chart(){

    this.chart1 = {
      data :{
        labels: this.dateGarfi,
        datasets: [{
            label: 'Backlog',
            data: this.payPastGarfi,
            backgroundColor: 'grey',
            borderColor: 'grey',
            borderWidth: 2,
        },
        {
          label: 'Cierre Ventas (Nuevo + Ext)',
          data: this.payTodayGarfi,
          backgroundColor: 'green',
          borderColor: 'green',
          borderWidth: 2,
        }

      ]
      },
      options:FormatChatsOptionBarGlobal(),
      plugins: [ChartDataLabels],
    };

    this.grafico = new Chart('chart-line',  {
      type: 'bar',
      stacked: true,
      data: this.chart1.data,
      options: this.chart1.options
     });
  }

  formSubmit(){
    let yearActual = moment(new Date()).format('YYYY');
    if(this.formSearch.value.optionTypeYear != 'año' && this.formSearch.value.optionTypeYear != 0){
      yearActual = this.formSearch.value.optionTypeYear;
    }
    let infoModeny = this.formSearch.value.currencyTransf
    if(infoModeny == 0){
      infoModeny = "2"
    }

    let type = this.listPlayOption.filter( n =>  n.id ==  this.formSearch.value.currencyTransf)
    if(type[0] != null){
      this.typeMoney = type[0].name
    }

    this.listTypeService = [];
    this.year = yearActual;
    this.iniService(yearActual, this.formSearch.value.optionTypePay, this.formSearch.value.optionState, this.formSearch.value.optionClient, this.formSearch.value.selectComercialOrigen, this.formSearch.value.selectOperation, this.formSearch.value.optionTypeService, infoModeny);
  }

  download(monthNumber:string){
    Swal.fire({
      title: 'Descargar',
      text: '¿Desea descargar el archivo?',
      icon: 'warning',
      showCancelButton:true,
      confirmButtonText: 'Descargar',
      cancelButtonText:"No, cancelar",
      heightAuto: false
    }).then((res) => {
      if (res.isConfirmed) {

        let yearActual = moment(new Date()).format('YYYY');
        if(this.formSearch.value.optionTypeYear != 'año' && this.formSearch.value.optionTypeYear != 0){
          yearActual = this.formSearch.value.optionTypeYear;
        }
        this.year = yearActual;
 
        let typePay = this.formSearch.value.optionTypePay;
        let stateSw = this.formSearch.value.optionState;
        let clientId =  this.formSearch.value.optionClient;

        let commercialOrigin= this.formSearch.value.selectComercialOrigen;
        let operation = this.formSearch.value.selectOperation;
        let typeService = this.formSearch.value.optionTypeService;

         let infoModeny = this.formSearch.value.currencyTransf
         if(infoModeny == 0){
           infoModeny = "2"
         }
     
         let type = this.listPlayOption.filter( n =>  n.id ==  this.formSearch.value.currencyTransf)
         if(type[0] != null){
           this.typeMoney = type[0].name
         }

        let urlInfo = 'dowload-excel-forecast?year='+this.year+'&monthNumber='+monthNumber+'&typePay='+typePay+'&stateSw='+stateSw+'&clientId='+clientId+'&commercialOrigin='+commercialOrigin+'&operation='+operation+'&serviceType='+typeService+'&currencyTransf='+infoModeny+''

        this.spinner.show()
       this.apiService.DownloadService(urlInfo).subscribe({
          next: (rs: any) => {
              let dataType = rs.type;
              let ext = dataType.split('/')
              let binaryData = [];
              binaryData.push(rs);
              let downloadLink = document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
              if(ext[1] != null){
                downloadLink.setAttribute('download','document.'+ext[1]);
              }
              this.spinner.hide();
              document.body.appendChild(downloadLink);
              downloadLink.click();
          },
          error: (error) => {
            const errorJson = JSON.parse(this.blobToString(error.error));
            if(errorJson.code == 1){
              this.spinner.hide()
              Swal.fire({title:errorJson.error,text: '',icon: 'error',heightAuto: false});
            }else{
              this.errorService.error(error);
            }
          },})
      }
      else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
        })

      }
    });
  }

  private blobToString(blob): string {
    const url = URL.createObjectURL(blob);
    let xmlRequest = new XMLHttpRequest();
    xmlRequest.open('GET', url, false);
    xmlRequest.send();
    URL.revokeObjectURL(url);
    return xmlRequest.responseText;
}
  
  limpButton(){
    location.replace(`/pdg/headship/forecast`)
  }
  

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}
